import {Component,} from '@angular/core';
import {MatDialog, MatDialogRef,} from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <h1 mat-dialog-title>{{ title }}</h1>
    <div mat-dialog-content>
      <p [style]="'white-space: pre-line;'">{{ content }}</p>
    </div>
    <div mat-dialog-actions [style]="'justify-content: flex-end;'">
      <button
        (keydown)="handleKeyPress($event)"
        type="button"
        *ngIf="!hideCancelBtn"
        mat-raised-button
        [color]="cancelBtnColor"
        (click)="cancel()"
      >
        <span [innerHTML]="cancelBtnText"></span>
      </button>
      <button
        (keydown)="handleKeyPress($event)"
        type="button"
        *ngIf="!hideCloseBtn"
        mat-raised-button
        [color]="closeBtnColor"
        (click)="close()"
      >
        <span [innerHTML]="closeBtnText"></span>
      </button>
    </div>
  `,
})
export class ConfirmDialog {
  constructor(
    public dialog: MatDialog,
    private confirmationDialog: MatDialogRef<ConfirmDialog>
  ) {}

  public title = '実行確認';
  public content = '';

  public cancelBtnText = 'CANCEL(<u>N</u>)'; // -> いいえ(<u>N</u>)
  public closeBtnText = 'OK(<u>Y</u>)'; // -> はい(<u>Y</u>)

  public cancelBtnAccesskey = 'n'; // -> n
  public closeBtnAccesskey = 'y'; // -> y

  public cancelBtnColor = 'primary';
  public closeBtnColor = 'accent';

  public hideCancelBtn = false;
  public hideCloseBtn = false;

  /**
   * ホットキー
   * @param event
   */
  handleKeyPress(event: KeyboardEvent): void {
    if (event.key.toLowerCase() === 'y') {
      // Yキーを押すと、ダイヤログを閉じて画面側にtrueを渡す
      this.close();
    }
    else if (event.key.toLowerCase() === 'n') {
      // Nキーを押すと、ダイヤログを閉じて画面側にfalseを渡す
      this.cancel();
    }
  }

  /**
   * Close/OK event
   */
  close(): void {
    this.confirmationDialog.close(true);
  }

  /**
   * Cancel/Dismiss event
   */
  cancel(): void {
    this.confirmationDialog.close(false);
  }
}
